module.exports.markRelatedNotificationsRead =  ->
  isRelatedAndUnread = (notification) =>
    notification.get('unread') &&
    !notification.get('data')?.card? &&
    notification.get('data').board?.id == @model.get('id')
  for notification in @modelCache.all('Notification') when isRelatedAndUnread(notification)
    notification.markRead()
  return
